import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlack = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.78141 11.3753C3.78141 12.4161 2.93121 13.2663 1.89046 13.2663C0.849705 13.2663 -0.000488281 12.4161 -0.000488281 11.3753C-0.000488281 10.3346 0.849705 9.48438 1.89046 9.48438H3.78141V11.3753Z",
			fill: "#E01E5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.73438 11.3753C4.73438 10.3346 5.58457 9.48438 6.62532 9.48438C7.66608 9.48438 8.51627 10.3346 8.51627 11.3753V16.11C8.51627 17.1508 7.66608 18.001 6.62532 18.001C5.58457 18.001 4.73438 17.1508 4.73438 16.11V11.3753Z",
			fill: "#E01E5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.62532 3.78189C5.58457 3.78189 4.73438 2.9317 4.73438 1.89095C4.73438 0.850194 5.58457 0 6.62532 0C7.66608 0 8.51627 0.850194 8.51627 1.89095V3.78189H6.62532Z",
			fill: "#36C5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.62516 4.73438C7.66591 4.73438 8.5161 5.58457 8.5161 6.62532C8.5161 7.66608 7.66591 8.51627 6.62516 8.51627H1.89046C0.849705 8.51627 -0.000488281 7.66608 -0.000488281 6.62532C-0.000488281 5.58457 0.849705 4.73438 1.89046 4.73438H6.62516Z",
			fill: "#36C5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2188 6.62532C14.2188 5.58457 15.0689 4.73438 16.1097 4.73438C17.1505 4.73438 18.0006 5.58457 18.0006 6.62532C18.0006 7.66608 17.1505 8.51627 16.1097 8.51627H14.2188V6.62532Z",
			fill: "#2EB67D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2658 6.62564C13.2658 7.6664 12.4156 8.51659 11.3748 8.51659C10.3341 8.51659 9.48389 7.6664 9.48389 6.62564V1.89095C9.48389 0.850194 10.3341 0 11.3748 0C12.4156 0 13.2658 0.850194 13.2658 1.89095V6.62564Z",
			fill: "#2EB67D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3739 14.2188C12.4146 14.2188 13.2648 15.0689 13.2648 16.1097C13.2648 17.1505 12.4146 18.0006 11.3739 18.0006C10.3331 18.0006 9.48291 17.1505 9.48291 16.1097V14.2188H11.3739Z",
			fill: "#ECB22E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3743 13.2663C10.3336 13.2663 9.4834 12.4161 9.4834 11.3753C9.4834 10.3346 10.3336 9.48438 11.3743 9.48438H16.109C17.1498 9.48438 18 10.3346 18 11.3753C18 12.4161 17.1498 13.2663 16.109 13.2663H11.3743Z",
			fill: "#ECB22E"
		})
	]
});
const ForwardRef = forwardRef(SvgSlack);
export { ForwardRef as ReactComponent };
